import { render } from "./CambiaStatoAlertModal.vue?vue&type=template&id=5b556ac4&ts=true"
import script from "./CambiaStatoAlertModal.vue?vue&type=script&lang=ts"
export * from "./CambiaStatoAlertModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__